import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface BaraCapabilities {
  can_act_as_bara_authority: boolean;
  branches: number[];
}

interface BaraState {
  capabilities: BaraCapabilities | null;
}

const initialState: BaraState = {
  capabilities: null,
};

const baraSlice = createSlice({
  name: 'bara',
  initialState,
  reducers: {
    setBaraCapabilities(state, action: PayloadAction<BaraCapabilities>) {
      state.capabilities = action.payload;
    },
    clearBaraCapabilities(state) {
      state.capabilities = null;
    },
  },
});

export const { setBaraCapabilities, clearBaraCapabilities } = baraSlice.actions;
export default baraSlice.reducer;
